<script>
  export default {
    props: ['relatorio', 'configuracao', 'projeto', 'filtros'],
    computed: {
      credito() {
        return this.relatorio.reduce((somatorio, subrubrica) => {
          return somatorio + subrubrica.valorCredito;
        }, 0);
      },
      debito() {
        return this.relatorio.reduce((somatorio, subrubrica) => {
          return somatorio + subrubrica.valorDebito;
        }, 0);
      },
      saldo() {
        return this.credito - this.debito;
      },
    }
  }
</script>

<template>
  <div class="col-md-12">
    <div class="ibox float-e-margins">
      <div class="ibox-content">

        <div class="table-responsive">
          <table class="table table-condensed no-margins">
            <thead>
            <tr>
              <th>Projeto</th>
              <th class="text-right">Período</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="no-border-right">{{ projeto.nomeProjeto}}</td>
              <td class="text-right">{{ filtros.dataInicio +' - '+ filtros.dataFim}}</td>
            </tr>
            </tbody>
          </table>

          <table class="table relatorio table-bordered no-margin-bottom" v-for="subrubrica in relatorio">
            <thead>
              <tr>
                <th>Subrubrica</th>
                <th class="text-right" style="width: 200px">Saldo anterior</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ subrubrica.descricao }}</td>
                <td class="text-right">{{ subrubrica.saldoAnterior | formatarNumero }}</td>
              </tr>
              <tr>
                <td class="text-right"><b>Crédito: {{ subrubrica.valorCredito | formatarNumero }}</b></td>
                <td class="text-right"><b>Débito: {{ subrubrica.valorDebito | formatarNumero }}</b></td>
              </tr>
            </tbody>
          </table>

          <table class="table relatorio margin-10">
            <tr>
              <td class="text-right"><b>Crédito: {{ credito | formatarNumero }}</b></td>
              <td class="text-right" style="width: 150px"><b>Débito: {{ debito | formatarNumero }}</b></td>
              <td class="text-right" style="width: 150px"><b>Saldo: {{ saldo | formatarNumero }} &nbsp;</b></td>
            </tr>
          </table>

          <hr class="no-margins">
        </div>

      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/Subrubricas/Sintetico.vue